import script from "./hotel-room.vue?vue&type=script&setup=true&lang=js"
export * from "./hotel-room.vue?vue&type=script&setup=true&lang=js"

import "./hotel-room.vue?vue&type=style&index=0&id=276b13c6&lang=css"

const __exports__ = script;

export default __exports__